import axios from "axios";
// List products with Api
export const GetAnswersByQuestion = async (question_id,languaje,jwt) => {

  let url = process.env.REACT_APP_ADMIN_API_URL + `/answersByQuestion`
  let data = "";
  let qs = require('qs');
  data = qs.stringify({
    'question_id': question_id,
    'language_id': languaje
  });
  try {
    const response = await axios.post(
        url,
        data,
      {
        headers: {
            'Authorization': 'Bearer '+jwt, 
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
    return response.data

  } catch (error) {
      console.log(error)
      sessionStorage.removeItem('userSelect');
    throw error;
  }
};